exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "drawdef-time-limit .calendar-disabled {\n  opacity: 1;\n  background-color: #dddddd; }\n\ndrawdef-time-limit p-calendar .ui-inputtext:disabled {\n  opacity: 1;\n  background-color: #dddddd; }\n\ndrawdef-time-limit button {\n  margin-top: 1.6rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/businessRules/drawdef-time-limit/drawDef-time-limit.component.scss
// module id = ../../../../../src/app/components/businessRules/drawdef-time-limit/drawDef-time-limit.component.scss
// module chunks = main